"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonAnimTypes = exports.CollapseAnimTypes = exports.ExpandAnimTypes = exports.TransformOrigin = exports.AnimSpeed = void 0;
var AnimSpeed;
(function (AnimSpeed) {
    AnimSpeed[AnimSpeed["SLOW"] = 500] = "SLOW";
    AnimSpeed[AnimSpeed["MEDIUM"] = 300] = "MEDIUM";
    AnimSpeed[AnimSpeed["FAST"] = 100] = "FAST";
})(AnimSpeed = exports.AnimSpeed || (exports.AnimSpeed = {}));
var TransformOrigin;
(function (TransformOrigin) {
    TransformOrigin["TOP_LEFT"] = "TOP_LEFT";
    TransformOrigin["TOP_MIDDLE"] = "TOP_MIDDLE";
    TransformOrigin["TOP_RIGHT"] = "TOP_RIGHT";
    TransformOrigin["CENTER_LEFT"] = "CENTER_LEFT";
    TransformOrigin["CENTER_MIDDLE"] = "CENTER_MIDDLE";
    TransformOrigin["CENTER_RIGHT"] = "CENTER_RIGHT";
    TransformOrigin["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    TransformOrigin["BOTTOM_MIDDLE"] = "BOTTOM_MIDDLE";
    TransformOrigin["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(TransformOrigin = exports.TransformOrigin || (exports.TransformOrigin = {}));
var ExpandAnimTypes;
(function (ExpandAnimTypes) {
    ExpandAnimTypes["EXPAND"] = "EXPAND";
    ExpandAnimTypes["EXPAND_PANEL"] = "EXPAND_PANEL";
    ExpandAnimTypes["SLIDE_FROM_LEFT"] = "SLIDE_FROM_LEFT";
    ExpandAnimTypes["SLIDE_FROM_RIGHT"] = "SLIDE_FROM_RIGHT";
    ExpandAnimTypes["SLIDE_FROM_TOP"] = "SLIDE_FROM_TOP";
    ExpandAnimTypes["SLIDE_FROM_BOTTOM"] = "SLIDE_FROM_BOTTOM";
    ExpandAnimTypes["FADE_IN"] = "FADE_IN";
})(ExpandAnimTypes = exports.ExpandAnimTypes || (exports.ExpandAnimTypes = {}));
var CollapseAnimTypes;
(function (CollapseAnimTypes) {
    CollapseAnimTypes["SLIDE_TO_LEFT"] = "SLIDE_TO_LEFT";
    CollapseAnimTypes["SLIDE_TO_RIGHT"] = "SLIDE_TO_RIGHT";
    CollapseAnimTypes["SLIDE_TO_TOP"] = "SLIDE_TO_TOP";
    CollapseAnimTypes["SLIDE_TO_BOTTOM"] = "SLIDE_TO_BOTTOM";
    CollapseAnimTypes["COLLAPSE"] = "COLLAPSE";
    CollapseAnimTypes["COLLAPSE_PANEL"] = "COLLAPSE_PANEL";
    CollapseAnimTypes["FADE_OUT"] = "FADE_OUT";
})(CollapseAnimTypes = exports.CollapseAnimTypes || (exports.CollapseAnimTypes = {}));
var CommonAnimTypes;
(function (CommonAnimTypes) {
    CommonAnimTypes["EXPAND"] = "EXPAND";
    CommonAnimTypes["EXPAND_PANEL"] = "EXPAND_PANEL";
    CommonAnimTypes["SLIDE_FROM_LEFT"] = "SLIDE_FROM_LEFT";
    CommonAnimTypes["SLIDE_FROM_RIGHT"] = "SLIDE_FROM_RIGHT";
    CommonAnimTypes["SLIDE_TO_LEFT"] = "SLIDE_TO_LEFT";
    CommonAnimTypes["COLLAPSE"] = "COLLAPSE";
    CommonAnimTypes["COLLAPSE_PANEL"] = "COLLAPSE_PANEL";
    CommonAnimTypes["SLIDE_TO_RIGHT"] = "SLIDE_TO_RIGHT";
    CommonAnimTypes["SLIDE_FROM_TOP"] = "SLIDE_FROM_TOP";
    CommonAnimTypes["SLIDE_TO_TOP"] = "SLIDE_TO_TOP";
    CommonAnimTypes["SLIDE_FROM_BOTTOM"] = "SLIDE_FROM_BOTTOM";
    CommonAnimTypes["SLIDE_TO_BOTTOM"] = "SLIDE_TO_BOTTOM";
    CommonAnimTypes["FADE_IN"] = "FADE_IN";
    CommonAnimTypes["FADE_OUT"] = "FADE_OUT";
    CommonAnimTypes["SCALE"] = "SCALE";
    CommonAnimTypes["SCALEFONT"] = "SCALEFONT";
    CommonAnimTypes["ROTATE"] = "ROTATE";
})(CommonAnimTypes = exports.CommonAnimTypes || (exports.CommonAnimTypes = {}));
//# sourceMappingURL=anim-values.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Animate/models/anim-values.js
// module id = 333
// module chunks = 8